import {
  Container,
  Card,
  Stack,
  Title,
  Text,
  Button,
  Box,
} from '@mantine/core';

function DisconnectedScreen({ statusMessage, onJoinNewGame }) {
  return (
    <Container size="sm" h="100dvh" sx={{ display: 'flex', alignItems: 'center' }}>
      <Card
        shadow="xl"
        p="xl"
        radius="lg"
        withBorder
        w="100%"
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Stack gap="xl" align="center">
          <Box ta="center">
            <Text size="4rem" mb="sm">⚠️</Text>
            <Title order={1} size="2rem" c="red">
              Connection Lost
            </Title>
          </Box>

          <Card
            p="lg"
            radius="md"
            w="100%"
            sx={{
              backgroundColor: 'rgba(220, 53, 69, 0.1)',
              border: '1px solid rgba(220, 53, 69, 0.3)',
              textAlign: 'center',
            }}
          >
            <Text c="red" fw={600} size="lg">
              {statusMessage}
            </Text>
          </Card>

          <Stack gap="md" w="100%">
            <Text size="lg" ta="center" c="dimmed">
              Don't worry! You can join another game anytime.
            </Text>
            
            <Button
              size="lg"
              fullWidth
              onClick={onJoinNewGame}
              variant="gradient"
              gradient={{ from: 'green', to: 'blue' }}
              sx={{ fontSize: '1.3rem' }}
            >
              🚀 Join New Game
            </Button>
          </Stack>

          <Box ta="center">
            <Text size="sm" c="dimmed">
              Thanks for playing Doodle Poodle! 🎭
            </Text>
          </Box>
        </Stack>
      </Card>
    </Container>
  );
}

export default DisconnectedScreen;